export default class BillingFilter {
  customerExternalId: string;

  customerIds: Array<string>;

  resultCenterId: string;

  competence: string;

  invoiceNumber: string;

  status: string;

  netValueOperator: string;

  netValue: string;

  dueDateStart: string;

  dueDateEnd: string;

  selectedCustomerOption: string = 'name';

  selectedBeneficiaryOption: string = 'name';

  beneficiary: string;

  product: Array<string>;

  discountedValueOperator: string;

  discountedValue: string;

  contractExternalId: number;

  invoicePaymentExternalIds: string;

  searchBy: string;

  searchValue: string;

  productId: number;

  frequency: string;

  constructor(obj: any) {
    this.customerExternalId = obj.customerExternalId || '';
    this.customerIds = obj.customerIds || [];
    this.resultCenterId = obj.resultCenterId || '';
    this.competence = obj.competence;
    this.invoiceNumber = obj.invoiceNumber || '';
    this.dueDateStart = obj.dueDateStart || '';
    this.dueDateEnd = obj.dueDateEnd || '';
    this.status = obj.status || '';
    this.netValueOperator = obj.netValueOperator || '';
    this.netValue = obj.netValue || '';
    this.beneficiary = obj.beneficiary || '';
    this.product = obj.product || [];
    this.discountedValueOperator = obj.discountedValueOperator || '';
    this.discountedValue = obj.discountedValue || '';
    this.contractExternalId = obj.contractExternalId;
    this.invoicePaymentExternalIds = obj.invoicePaymentExternalIds || '';
    this.searchBy = obj.searchBy || '';
    this.searchValue = obj.searchValue || '';
    this.productId = obj.productId;
    this.frequency = obj.frequency || '';
  }

  public static of(obj: any) {
    return new BillingFilter(obj || {});
  }

  get isTradingNameFetch(): boolean {
    return this.selectedCustomerOption === 'tradingName'
  }

  get isDocumentFetch(): boolean {
    return this.selectedCustomerOption === 'document'
  }

  get isBeneficiaryTradingNameFetch(): boolean {
    return this.selectedBeneficiaryOption === 'tradingName'
  }
}
